import React, { useState, useCallback } from 'react';
import { Button } from 'antd';
import { DownloadOutlined } from '@ant-design/icons';

const RankingDownloadResults = ({ API_URL, author_email, run_id }) => {
  const [isLoading, setIsLoading] = useState(false);

  // Use useCallback to memoize the function and prevent unnecessary re-creations
  const getPresignedLink = useCallback(
    async (filename) => {
      setIsLoading(true);
      try {
        const response = await API_URL.get('get-presigned-url', {
          params: { author_email, run_id, filename },
        });
        const { signed_url: presignedUrl } = response.data;
        downloadFile(presignedUrl);
      } catch (error) {
        console.error('Error fetching presigned URL:', error.message);
      } finally {
        setIsLoading(false);
      }
    },
    [author_email, run_id]
  );

  // Extract file download logic into a separate function
  const downloadFile = (url) => {
    const link = document.createElement('a');
    link.href = url;
    link.download = ''; // Optional: Provide a default filename here if needed
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <Button
      icon={<DownloadOutlined />}
      size="small"
      type="primary"
      loading={isLoading}
      disabled={isLoading}
      onClick={() => getPresignedLink('Ranking_Output.zip')}
    >
      Click here to download all reports in a zip
    </Button>
  );
};

export default RankingDownloadResults;
